import React, { MouseEvent } from 'react';
import { useXAxisContext } from 'utils/components/TimeSeriesChart/XAxisContext';
import Legend from 'utils/components/Legend/Legend';
import { TooltipText } from 'utils/components/Tooltip/Tooltip';
import classNames from 'classnames';
import { useHorizontalZoomContext } from 'utils/components/Zoom/ZoomContext';

export interface TimeSeriesLegendProps {
    className: string;
    label: string;
    value?: string;
    containerLeft: number;
    suffix?: string;
    twoColourBorder?: boolean;
    hideDashWhenEmpty?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    tooltip?: TooltipText;
}

export default function TimeSeriesLegend(props: TimeSeriesLegendProps) {
    const {
        className: propsClassName,
        label,
        value,
        suffix,
        twoColourBorder,
        containerLeft,
        hideDashWhenEmpty,
        disabled,
        onClick,
        tooltip,
    } = props;
    const xAxisContext = useXAxisContext();
    const { timePointerRef } = xAxisContext;

    const { zoomedXScale: xScale } = useHorizontalZoomContext();

    const { publish } = timePointerRef.current;

    const onPointerMove = (event: MouseEvent<HTMLDivElement>) => {
        const x = event.clientX - containerLeft - 1;
        const time = xScale.invert(x);
        publish({ x, time });
    };

    const onMouseLeave = () => {
        publish({ x: undefined, time: undefined });
    };

    const className = classNames('TimeSeriesLegend', propsClassName);

    return (
        <Legend
            className={className}
            label={label}
            onPointerMove={onPointerMove}
            onMouseLeave={onMouseLeave}
            value={value}
            suffix={suffix}
            twoColourBorder={twoColourBorder}
            hideDashWhenEmpty={hideDashWhenEmpty}
            disabled={disabled}
            onClick={onClick}
            tooltip={tooltip}
        />
    );
}
